import defaultSettings from "@/settings";
import { getDocType } from "@/api/docType";

const { showSettings, fixedHeader, sidebarLogo } = defaultSettings;

const state = {
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  regional_id: 2,
  federal_id: 1,
};

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (Object.hasOwnProperty.call(state, key)) {
      state[key] = value;
    }
  },
  SET_REGIONAL_ID: (state, payload) => {
    state.regional_id = payload;
  },
  SET_FEDERAL_ID: (state, payload) => {
    state.federal_id = payload;
  },
};

const actions = {
  async getTypes({ commit }) {
    let data = null;
    await getDocType()
      .then((res) => (data = res))
      .catch((err) => console.log(err));
    const find_regional = data?.find((el) => el.type === "regional");
    const find_federal = data?.find((el) => el.type === "federal");
    commit("SET_REGIONAL_ID", find_regional?.id);
    commit("SET_FEDERAL_ID", find_federal?.id);
  },
  changeSetting({ commit }, data) {
    commit("CHANGE_SETTING", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
